import { render, staticRenderFns } from "./OtherCostTypeAssignment.vue?vue&type=template&id=622f0f38&scoped=true&"
import script from "./OtherCostTypeAssignment.vue?vue&type=script&lang=ts&"
export * from "./OtherCostTypeAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./OtherCostTypeAssignment.vue?vue&type=style&index=0&id=622f0f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f0f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VRow,VSelect,VTooltip})
